import { useState } from "react";
import { Button } from "../components/ui/button";
import { PlayerAvatar } from "./PlayerAvatar";
import { ComparePlayersDialog } from "./ComparePlayersDialog";
import { Swords } from "lucide-react";

export function PlayerStatsView({ standings, onSelectPlayer }) {
  const [compareOpen, setCompareOpen] = useState(false);
  const options = standings.map((p) => ({ id: p.player_id, name: p.name }));
  return (
    <div className="space-y-5" data-testid="player-stats-view">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-400">
            Statistiche Giocatori
          </div>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-white">
            Analisi Dettagliata
          </h2>
        </div>
        <Button
          data-testid="open-compare-btn"
          onClick={() => setCompareOpen(true)}
          size="sm"
          className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold uppercase text-xs tracking-wide"
        >
          <Swords className="w-4 h-4 mr-1.5" />
          Confronta
        </Button>
      </div>

      <ComparePlayersDialog open={compareOpen} onOpenChange={setCompareOpen} options={options} />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {standings.map((p) => {
          const winRate = p.played ? Math.round((p.wins / p.played) * 100) : 0;
          const deg = (winRate / 100) * 360;
          return (
            <button
              key={p.player_id}
              data-testid={`player-stat-card-${p.player_id}`}
              onClick={() => onSelectPlayer(p.player_id)}
              className="group ap-card text-left p-5"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="relative shrink-0">
                  <div
                    className="w-14 h-14 rounded-full flex items-center justify-center"
                    style={{ background: `conic-gradient(#10B981 ${deg}deg, #1f2937 ${deg}deg)` }}
                  >
                    <div className="w-[46px] h-[46px] rounded-full bg-slate-900 flex items-center justify-center overflow-hidden">
                      <PlayerAvatar id={p.player_id} name={p.name} size={42} ring={false} />
                    </div>
                  </div>
                  {p.position <= 3 && (
                    <span
                      className="absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center font-display font-black text-[10px] text-slate-950"
                      style={{ background: ["#F59E0B", "#9CA3AF", "#D97706"][p.position - 1] }}
                    >
                      {p.position}
                    </span>
                  )}
                </div>
                <div className="min-w-0">
                  <div className="font-bold text-white truncate group-hover:text-emerald-400 transition-colors">
                    {p.name}
                  </div>
                  <div className="font-mono text-xs text-slate-500">#{p.position} · {winRate}% win</div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-2 text-center">
                <div className="rounded-xl bg-slate-950/60 py-2">
                  <div className="font-mono font-black text-lg text-emerald-400">{p.points}</div>
                  <div className="text-[10px] uppercase tracking-wider text-slate-500">Punti</div>
                </div>
                <div className="rounded-xl bg-slate-950/60 py-2">
                  <div className="font-mono font-black text-lg text-white">{p.wins}-{p.losses}</div>
                  <div className="text-[10px] uppercase tracking-wider text-slate-500">V-P</div>
                </div>
                <div className="rounded-xl bg-slate-950/60 py-2">
                  <div className="font-mono font-black text-lg text-cyan-400">
                    {p.games_diff > 0 ? "+" : ""}
                    {p.games_diff}
                  </div>
                  <div className="text-[10px] uppercase tracking-wider text-slate-500">Diff</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
